<template>
  <transition name="bottom" appear>
    <q-page-sticky  position="bottom-right" :offset="[18, 18]" key="v">
      <q-btn round small
             color="secondary" @click="goPrev" icon="arrow_back" :disabled="prevDisabled" />
      <span>{{navLabel}}</span>
      <q-btn round small
             color="secondary" @click="goNext" icon="arrow_forward" :disabled="nextDisabled" />
    </q-page-sticky >
  </transition>
</template>
<style>

</style>

<script>


export default {
  name: 'navBtn',
  props: {
    goPrev: {
      type: Function,
      required: true,
    },
    goNext: {
      type: Function,
      required: true,
    },
  },
  components: {
  },
  computed: {
    navLabel() {
      if (this.$store.state.total > 0) {
        if (this.$store.state.active > -1) {
          return `${this.$store.state.active + 1}/${this.$store.state.total}`;
        }
        return `?/${this.$store.state.total}`;
      }
      return '';
    },
    nextDisabled() {
      return (this.$store.state.active >= this.$store.state.total - 1)
        || (this.$store.state.active === -1);
    },
    prevDisabled() {
      return this.$store.state.active <= 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/nav-btn.vue